'use client';

import React from 'react';
import { IAlternative } from '../../types';
import { CustomLink } from '../link/link.comp';
import { StyledPlatofrmHero } from './alternativesHero.styles';
import { Header } from '../header/header.comp';

interface IAlternativesHeroProps {
    alternative?: IAlternative;
}

export const AlternativesHero = ({ alternative }: IAlternativesHeroProps) => {
    const title = alternative ? `Common Ninja vs. ${alternative.name}` : `Widget Provider Comparison Library`;
    const subtitle = alternative ? alternative.subTitle : `Choosing a good widget provider for your website is not a simple decision. To help you in this endeavor, we’ve created these head-to-head comparisons, to make picking the right widget provider for your needs easier.`;

    return (
        <StyledPlatofrmHero>
            <Header />
            <div className="hero-wrapper">
                <h1>{title}</h1>
                <h2>{subtitle} </h2>
                {alternative &&
                    <CustomLink
                        href={`/widgets`}
                        variant="gradient"
                    >
                        Discover Powerful Widgets
                    </CustomLink>
                }
            </div>
        </StyledPlatofrmHero>
    );
};
